import React from "react";
import "../../../../css/Marketing/FinancialPromotions/Buttons/FlagRatingPills.css";

/**
 * RatePill component for rating flags as Correct, Partly Correct, or Incorrect.
 * Props:
 * - selected: boolean, whether this pill is selected
 * - label: string, display label
 * - color: string, background color (CSS value)
 * - onClick: function to call when pill is clicked
 * - disabled: boolean, disables interaction
 */
const RatePill = ({ selected, label, tone, onClick, disabled }) => (
  <button
    type="button"
    className={`fp-flag-rating-pill-btn rate-pill rate-pill--${tone || "neutral"} ${selected ? "is-selected" : ""}`}
    onClick={disabled ? undefined : onClick}
    disabled={disabled}
  >
    <span className="fp-flag-rating-pill-label FP_Help_Text">{label}</span>
  </button>
);

export default RatePill;
